<div class="jumbotron jumbotron-fluid mb-0 pt-0 pb-0 bg-transparent">
  <div
    class="jumbotron__img"
    [ngStyle]="{ 'background-image': 'url(' + items?.imagePath?.src + ')' }"
  ></div>
  <div class="container px-0 px-md-2">
    <div
      [ngClass]="items?.contentClasses"
      class="jumbotron__content position-relative py-md-6"
    >
      <div class="jumbotron__content-wrapper text-start">
        <div class="jumbotron__brandbox" [ngClass]="items?.brandBoxClasses">
          @if (items?.title) {
            <h1
              [ngClass]="items?.titleClasses"
              class="fw-bolder"
              [innerHtml]="items?.title"
              wlAutomationId="jumbotron-title"
            ></h1>
          }
          @if (items?.subtitle) {
            <h2
              [ngClass]="items?.subtitleClasses"
              class="fw-light"
              [innerHtml]="items?.subtitle"
            ></h2>
          }
        </div>
        @if (items?.buttonText) {
          <div class="text-start">
            <a
              class="btn btn-primary"
              [ngClass]="items?.buttonClasses"
              href="{{ items?.url }}"
              role="button"
              [innerHtml]="items?.buttonText"
              title="{{ items?.buttonText }}"
            ></a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
